<template>
    <div id="app">
        <app-nav></app-nav>
        <router-view class="main"></router-view>
        <app-footer></app-footer>
    </div>
</template>

<script>
import $auth from "@/services/auth.js";
import AppNav from "@/components/global/AppNav";
import AppFooter from "@/components/global/AppFooter";

export default {
    components: {
        AppNav,
        AppFooter
    },
}
</script>

<style scoped>
#app {
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

@media (min-width: 768px) {
    .main {
        min-height: 70vh;
        margin-top: 77px;
    }
}
</style>
